import React from 'react';
import { NavLink } from 'react-router-dom';

import { scrollTop } from '../../../../utils/scroll-top';
import { bindActionCreators } from 'redux';
import { menu } from '../../../../actions';
import { connect } from 'react-redux';
import './MenuItem.scss';
import { NavigationItem } from '../../../../types/navigation';
import { __ } from '../../../../services/translation';

interface Props extends NavigationItem {
  toggleMenu: () => void;
  desktop?: boolean;
  collapsed?: boolean;
}

class MenuItem extends React.Component<Props> {
  private handleItemClick = (): void => {
    const { onClick, toggleMenu } = this.props;
    if (typeof onClick !== 'undefined') onClick();
    toggleMenu();
  };

  render(): any {
    const { link, icon, name, desktop, collapsed } = this.props;
    const itemClass = `main-menu-item ${!icon ? 'sub-menu-item' : ''} ${desktop ? 'desktop' : ''} ${collapsed ? 'collapsed' : ''}`;
    const label = __(name);
    const displayLabel = collapsed ? label.substring(0, 3) + (label.length > 3 ? '.' : '') : label;
    if (link) {
      return (
        <NavLink to={link} title={label} className={itemClass} activeClassName="active" onClick={this.handleItemClick}>
          {displayLabel}
        </NavLink>
      );
    } else {
      return (
        <a role="button" tabIndex={0} title={label} className={itemClass} onClick={this.handleItemClick}>
          {displayLabel}
        </a>
      );
    }
  }
}

const mapDispatchToProps = (dispatch: any) => bindActionCreators({ toggleMenu: menu.toggleMenu }, dispatch);

export default connect(null, mapDispatchToProps)(MenuItem);
